import { CardMedia } from '@mui/material';
import { CCardMediaProps } from 'types/atoms';
import customTwMerge from 'utils/twMerge';

export default function CCardMedia({
  alt,
  imgSrc,
  containerClassName,
  className,
  children,
}: CCardMediaProps) {
  return children ? (
    <div
      className={customTwMerge(
        'flex w-14 shrink-0 items-center justify-center rounded-xl bg-neutral-background2',
        containerClassName
      )}
    >
      {children}
    </div>
  ) : (
    <div
      className={customTwMerge(
        'flex w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-neutral-background2',
        containerClassName
      )}
    >
      <CardMedia
        component="img"
        className={customTwMerge('', className)}
        image={imgSrc ?? new URL('assets/svg/user-placeholder.svg', import.meta.url).href}
        alt={alt}
      />
    </div>
  );
}

